export default function freshSalesDealUrl(
  freshSalesDealId?: string
): string | undefined {
  const urlTemplate: string | undefined =
    process.env.VUE_APP_FRESHSALES_DEAL_URL_TEMPLATE;

  if (!freshSalesDealId || !urlTemplate) {
    return undefined;
  }

  const url = urlTemplate.replace(
    "{DEAL_ID}",
    encodeURIComponent(freshSalesDealId)
  );

  if (!url) {
    return undefined;
  }

  return url;
}
